import { trackPromise } from "react-promise-tracker";
import { axiosBridge } from "../network/AxiosBridge";
import { API_URL, StatusCodes } from "../network/Configurations";

const login = (request: any): Promise => {
  return new Promise((resolve, reject) => {
    trackPromise(
      axiosBridge
        .post(API_URL.LOG_IN, request)
        .then((response) => {
          if (
            response.data.code === StatusCodes.SUCCESS ||
            response.data.code === StatusCodes.SUCCESS_WAIT
          ) {
            resolve(response.data);
          } else reject(response.data);
        })
        .catch((error) => {
          console.log(error.response);
          reject(error);
        })
    );
  });
};

const verifyOtp = (request: any): Promise => {
  return new Promise((resolve, reject) => {
    trackPromise(
      axiosBridge
        .post(API_URL.VERIFY_OTP, request)
        .then((response) => {
          if (response.data.code === StatusCodes.SUCCESS) {
            resolve(response.data);
          } else reject(response.data);
        })
        .catch((error) => {
          console.log(error.response);
          reject(error);
        })
    );
  });
};

const logout = (): Promise => {
  return new Promise((resolve, reject) => {
    trackPromise(
      axiosBridge
        .post(API_URL.LOGOUT)
        .then((response) => {
          if (response.data.code === StatusCodes.SUCCESS) {
            resolve(response.data);
          } else reject(response.data);
        })
        .catch((error) => {
          console.log(error.response);
          reject(error);
        })
    );
  });
};

const uploadProfilePic = (request: any): Promise => {
  return new Promise((resolve, reject) => {
    trackPromise(
      axiosBridge
        .post(API_URL.UPLOAD_PROFILE_PIC, request, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((response) => {
          if (response.data.code === StatusCodes.SUCCESS) {
            resolve(response.data);
          } else reject(response.data);
        })
        .catch((error) => {
          reject(error);
        })
    );
  });
};

export const AuthService = {
  login,
  verifyOtp,
  logout,
  uploadProfilePic,
};
